import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { createVoltage, updateVoltage } from '../../app/store/actions/voltage';
import FIELDS from '../../data/fields';

class VoltageForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      id: null,
      toEdit: false,
      isLoading: false,
      description: '',
      messageError: '',
      messageSuccess: '',
      start: null,
      end: null,
    };
  }

  componentDidMount = async () => {
    if (this.props.back.location.selected) {
      await this.setSelected(this.props.back.location.selected);
    }
  }

  setSelected = async (selected) => {
    this.setState({
      toEdit: true,
      id: selected.id,
      start: parseFloat(selected.start),
      end: parseFloat(selected.end),
    });
  }

  setValue = (att, value) => {
    this.setState({ [att]: value });
  }

  goBack = () => {
    this.props.back.goBack();
  };

  create = async () => {
    const { start, end } = this.state;
    if (!start || !end) {
      this.setState({ messageError: I18n.t('fieldsNotReported') });
    } else {
      this.setState({ isLoading: true });
      try {
        const voltageRange = `Desde ${start}V hasta ${end}V`;
        await this.props.createVoltage({ voltageRange, start, end });
        await this.setState({ messageSuccess: I18n.t('registrationPerformed') });
        await this.goBack();
      } catch (err) {
        const error = err.response && err.response.data && err.response.data.error
        this.setState({ messageSuccess: '' })
        if (error && error.message) {
          const messageError = (error.code && error.details) ?
            `${error.code} - ${error.details} | ${error.message}`
            : error.message;

          this.setState({ messageError: messageError })
        } else {
          this.setState({ messageError: I18n.t('errorOcurred') })
        }
      }
      this.setState({ isLoading: false });
    }
  }

  update = async () => {
    const { id, start, end } = this.state;
    if (!id || !start || !end) {
      this.setState({ messageError: I18n.t('fieldsNotReported') });
    } else {
      this.setState({ isLoading: true });
      try {
        const voltageRange = `Desde ${start}V hasta ${end}V`;
        await this.props.updateVoltage({ id, voltageRange, start, end });
        await this.setState({ messageSuccess: I18n.t('changeMade') });
        await this.goBack();
      } catch (err) {
        const error = err.response && err.response.data && err.response.data.error
        this.setState({ messageSuccess: '' })

        if (error && error.message) {
          const messageError = (error.code && error.details) ?
            `${error.code} - ${error.details} | ${error.message}`
            : error.message;

          this.setState({ messageError: messageError })
        } else {
          this.setState({ messageError: I18n.t('errorOcurred') })
        }
      }
      this.setState({ isLoading: false });
    }
  }

  render() {
    const {
      isLoading, messageSuccess, start, end, messageError, toEdit,
    } = this.state;

    return (
      <div className="form-main">
        <h2 className="header-form-client">
          {`${(toEdit) ? I18n.t('editar') : I18n.t('new')} ${I18n.t('voltage')}`}
        </h2>
        <form>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('start')}
            </p>
            <input
              type="number"
              onChange={e => this.setValue('start', `${e.target.value}`)}
              value={start}
              className="form-control"
              placeholder=""
              maxLength={FIELDS.max}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('end')}
            </p>
            <input
              type="number"
              onChange={e => this.setValue('end', `${e.target.value}`)}
              value={end}
              className="form-control"
              placeholder=""
              maxLength={FIELDS.max}
            />
          </div>

          {!!messageSuccess && <p className="color-green margin-top-10">{messageSuccess}</p>}
          {!!messageError && <p className="color-red margin-top-10">{messageError}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              {I18n.t('return')}
            </button>

            <button
              type="button"
              className="btn btn-dark"
              onClick={() => (!toEdit) ? this.create() : this.update()}
              disabled={isLoading}
            >
              {(!toEdit) ? I18n.t('toSend') : I18n.t('resend')}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (/* state */) => ({});

const mapDispatchToProps = dispatch => ({
  createVoltage: (newVoltage) => dispatch(createVoltage(newVoltage)),
  updateVoltage: (updVoltage) => dispatch(updateVoltage(updVoltage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VoltageForm);
